__turbopack_context__.v({
  "card": "Donate-module__NXB32W__card",
  "check": "Donate-module__NXB32W__check",
  "grid": "Donate-module__NXB32W__grid",
  "heading": "Donate-module__NXB32W__heading",
  "intro": "Donate-module__NXB32W__intro",
  "lead": "Donate-module__NXB32W__lead",
  "link": "Donate-module__NXB32W__link",
  "notice": "Donate-module__NXB32W__notice",
  "nowrap": "Donate-module__NXB32W__nowrap",
  "questions": "Donate-module__NXB32W__questions",
  "subheading": "Donate-module__NXB32W__subheading",
  "widget": "Donate-module__NXB32W__widget",
});
